import type { ReactNode } from 'react';

export const symbol_sensors_krx: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M151-394q11 41 31 77 6 11 4 23.5T173-274q-11 8-23.5 4.5T131-284q-25-44-38-93T80-480q0-54 13-102.5t38-92.5q7-11 19-15t23 4q11 7 13 19.5t-4 23.5q-20 36-31 77t-11 86q0 45 11 86Zm159 84q-70-70-70-170t70-170q70-70 170-70t170 70q70 70 70 170t-70 170q-70 70-170 70t-170-70Zm297.5-42.5Q660-405 660-480t-52.5-127.5Q555-660 480-660t-127.5 52.5Q300-555 300-480t52.5 127.5Q405-300 480-300t127.5-52.5ZM808-566q-11-41-31-77-6-11-4-23.5t13-19.5q11-8 23-4t19 15q25 44 38 92.5T879-480q0 54-13 103t-38 93q-7 11-19 14.5t-23-4.5q-11-7-13-19.5t4-23.5q20-36 31-77t11-86q0-45-11-86Zm-328 86Z"
		/>
	</svg>
);
